import React from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const COLS = [
  ['current', 'Current'],
  ['d30', '30 days'],
  ['d60', '60 days'],
  ['rtw', 'Return to Work'],
];

const ROWS = [
  { key: 'sitting', label: 'Sitting (hrs/day)', type: 'number' },
  { key: 'standing', label: 'Standing (hrs/day)', type: 'number' },
  { key: 'walking', label: 'Walking (hrs/day)', type: 'number' },
  { key: 'lifting_lbs', label: 'Lifting limit (lbs)', type: 'number' },
  { key: 'fine_motor', label: 'Fine motor restriction', type: 'yn' },
  { key: 'driving', label: 'Driving restriction', type: 'yn' },
  { key: 'cognitive', label: 'Cognitive restriction', type: 'yn' },
];

export function FunctionalCapacityMatrix({ value, onChange, readOnly }) {
  const update = (col, row, v) => {
    const next = { ...(value || {}) };
    next[col] = { ...(next[col] || {}), [row]: v };
    onChange(next);
  };
  return (
    <div className="rounded-xl border bg-card overflow-x-auto" data-testid="fc-matrix">
      <table className="min-w-full text-sm">
        <thead className="bg-secondary text-secondary-foreground text-xs">
          <tr>
            <th className="px-3 py-2 text-left font-medium">Metric</th>
            {COLS.map(([k, l]) => <th key={k} className="px-3 py-2 text-left font-medium">{l}</th>)}
          </tr>
        </thead>
        <tbody>
          {ROWS.map((row) => (
            <tr key={row.key} className="border-t">
              <td className="px-3 py-2 text-muted-foreground">{row.label}</td>
              {COLS.map(([col]) => {
                const v = (value || {})[col]?.[row.key] ?? '';
                if (row.type === 'yn') {
                  return (
                    <td key={col} className="px-3 py-2">
                      <Select value={String(v || '')} onValueChange={(val) => update(col, row.key, val)} disabled={readOnly}>
                        <SelectTrigger className="h-8" data-testid={`fc-${col}-${row.key}`}><SelectValue placeholder="—" /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="none">—</SelectItem>
                          <SelectItem value="No">No</SelectItem>
                          <SelectItem value="Yes">Yes</SelectItem>
                          <SelectItem value="Yes (avoid)">Yes (avoid)</SelectItem>
                        </SelectContent>
                      </Select>
                    </td>
                  );
                }
                return (
                  <td key={col} className="px-3 py-2">
                    <Input className="h-8" readOnly={readOnly} type="number" value={v} onChange={(e) => update(col, row.key, e.target.value)} data-testid={`fc-${col}-${row.key}`} />
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
